import { useContext } from 'react';
import { Context } from './Context';
export const useApprovalWorkflow = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useApprovalWorkflow hook must be used as a child to <ApprovalWorkflowProvider />');
    }
    return context;
};
